<template>
  <div class="container-fluid">
    <div class="row mt-5">
      <div class="col-md-12 text-center"></div>
    </div>
    <div class="row mt-3">
      <div class="col-md-5 text-center justify-content-md-center">
        <div class="card">
          <div class="card-body py-0">
            <img src="img/tawi-holdings.png" height="125px" />
            <h5 class="text-uppercase">TAWI Palletizing Game</h5>
            <h1 class="text-uppercase"><strong>LEADERBOARD</strong></h1>
           <!-- <img src="img/leader-board-01.svg" height="100px" style="margin-bottom: -15px;" /> -->
           <img src="img/uniqlo-gc.gif" height="450px" style="margin-top: 20px;"/>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="card">
          <div class="card-body">
            <table class="table">
              <thead>
                <tr id="label" class="text-uppercase">
                  <th></th>
                  <th scope="col">Rank</th>
                  <th scope="col">Name</th>
                  <th scope="col">Company</th>
                  <th scope="col">Time</th>
                </tr>
              </thead>
              <tbody>
                <LeaderBoardItem 
                  v-for="(item, index) in rankings" 
                  :item="item" 
                  :index="index" 
                  :key="item.id" 
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rankingsCollection } from "../../config/firebase";
import LeaderBoardItem from './LeaderBoardItem';

export default {
  name: "LeaderBoard",
  components: {
    LeaderBoardItem
  },
  data() {
    return {
      rankings: []
    };
  },
  firestore: {
    rankings: rankingsCollection
      .orderBy("minutes")
      .orderBy("seconds")
      .limit(10)
  }
};
</script>

<style scoped>
.card {
  border: none;
}
.th, #label {
  background-color: #8190BB;
  color: #fff;
  font-size: 20px;
}

</style>